// extracted by mini-css-extract-plugin
export default {"header_logo":"Header_header_logo__vK2PR","header":"Header_header__OPGSD"};